import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
  usePagination,
  IconButton,
  Menu,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
  Icon,
  TextField,
  InputAdornment,
  Avatar,
  Dialog,
  DialogContent,
  FormControl,
  DialogActions,
} from "@mui/material";
import Popover from '@mui/material/Popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
// import Request from "../../components/home/Request";
// import { getMyRequestSuccess } from "../../actions";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect } from "react";
import { styled, alpha } from "@mui/material/styles";
import cssVariables from "../../../theme/cssVariables";
import { ReactComponent as FilterIcon } from "../../../icons/filter.svg";
import { ReactComponent as EyeIcon } from "../../../icons/eye.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete.svg";
import { ReactComponent as CancelDelete } from "../../../icons/cancel-delete.svg";
import fileBrowser from "../../../icons/file-browser.svg";
import { getGoalList } from "../../../actions/mygoal";
import { deleteMyGoal, putDeleteMyGoal, getMyGoalDetail, getMyGoalProgress, putUpdateProgress } from "../../../actions/mygoal";
import ConfirmDialog from "../../../components/ConfirmDialog";
import SimpleDialog from "../../../components/SimpleDialog";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Search from "@mui/icons-material/Search";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import * as Util from "../../../services/global.service";
import dayjs from 'dayjs'
import ClearIcon from "@mui/icons-material/Clear";

const MyGoalList = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { state } = useLocation();

  function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
      paginationRoot: {
        color: `${cssVariables.color.primary}`,
        backgroundColor: "white!important",
        minWidth: "30px!important",
        padding: "5px!important",
      },
      paginationSelected: {
        color: "white!important",
        border: "1px solid rgba(93, 161, 150, 0.5)!important",
        backgroundColor: `${cssVariables.color.primary}!important`,
        minWidth: "30px!important",
        padding: "5px!important",
      },

    });
    const classes = useStyles();
    const List = styled("ul")({
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
    });
    const { items } = usePagination({
      count: props.count,
      showFirstButton: true,
      showLastButton: true,
    });
    return (
      <nav>
        <List>
          {items.length > 0 ? (
            items.map(({ page, type, selected, ...item }, index) => {
              let children = null;
              selected = type === "page" && page === props.selected ? props.selected : selected
              if (type === "start-ellipsis" || type === "end-ellipsis") {
                children = "…";
              } else if (type === "page") {
                children = (
                  <Button
                    {...item}
                    size="small"
                    type="button"
                    style={{
                      fontWeight: selected ? "bold" : undefined,
                    }}
                    variant="outlined"
                    classes={{
                      root: selected
                        ? classes.paginationSelected
                        : classes.paginationRoot,
                    }}
                    sx={{ margin: "0 5px" }}
                  >
                    {page}
                  </Button>
                );
              } else if (type === "first" || type === "last") {
                children = (
                  <Button
                    {...item}
                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                    size="small"
                    type="button"
                    style={{
                      fontWeight: selected ? "bold" : undefined,
                    }}
                    variant="outlined"
                    classes={{
                      root: selected
                        ? classes.paginationSelected
                        : classes.paginationRoot,
                    }}
                    sx={{ margin: "0 5px" }}
                  >
                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                  </Button>
                );
              } else {
                children = (
                  <Button
                    {...item}
                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                    size="small"
                    type="button"
                    variant="outlined"
                    style={{ textTransform: 'none' }}
                    classes={{
                      root: classes.paginationRoot,
                    }}
                  >
                    {type === "previous"
                      ? `${t('label.previous')}`
                      : type === "next"
                        ? `${t('label.next')}`
                        : ""}
                  </Button>
                );
              }
              return <li key={index}>{children}</li>;
            })

          ) : (
            <></>
          )}
          {props.setCurrentPage(items)}
        </List>
      </nav>
    );
  }
  const handleSetCurrentPage = (value) => {
    const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
    setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
  };

  // on click
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const openOption = Boolean(anchorEl);

  const handleClick = (event, data) => {
    console.log(data);
    setGoalDetailData(data)
    setSerialDetail(data.serial)
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl2(null);
  };
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleCloseDialog = () => {
    openUpdateDialog(false);
  };
  const handleOption = (option, data) => {
    setAnchorEl(null);
    if (option == t('mygoal.label.delete') && data?.progress_status?.description !== 'pending_delete') {
      openConfirmDeleteDialog(true)
    } else if (option === t('mygoal.label.delete') && data?.progress_status?.description === 'pending_delete') {
      openCancelDeleteDialog(true)
    } else if (option == t('mygoal.label.viewDetail')) {
      Object.assign(data, { goalSerial: data.serial })
      Object.assign(data, { serial: evaluatorSerial })
      Object.assign(data, { statusForm: state.statusForm })
      Object.assign(data, { isCreatable: state.isCreatable })
      Object.assign(data, { historyTemplate: state.historyTemplate })
      if (data.is_cascaded) {
        Object.assign(data, { sendGoalType: data.type?.code === 'team' ? 2 : data?.type.code === 'personal' ? 3 : 1 })
      }
      Object.assign(data, { viewSerial: state.viewSerial })
      goto(`/mygoal-detail/${serialDetail}`, data)
    } else if (option == t('mygoal.label.edit')) {
      Object.assign(data, { goalSerial: data.serial })
      Object.assign(data, { serial: evaluatorSerial })
      Object.assign(data, { historyTemplate: state.historyTemplate })
      if (data.is_cascaded) {
        Object.assign(data, { sendGoalType: data.type?.code === 'team' ? 2 : data?.type.code === 'personal' ? 3 : 1 })
        goto('/mygoal-choose-type', data)
      } else {
        goto('/mygoal-create/edit', data)
      }
    }
  };
  const options = [
    t('mygoal.label.viewDetail'),
    t('mygoal.label.edit'),
    t('mygoal.label.delete')
  ];
  const handleConfirmDeleteList = async () => {
    openConfirmDeleteDialog(false)
    // Delete API
    dispatch(deleteMyGoal(serialDetail))
      .then(resp => {
        if (resp.success) {
          let removeArray = dataList.filter((obj) => {
            return obj.serial !== serialDetail;
          })
          setDataList(removeArray)
          openSuccessDeleteDialog(true)
        }
      })
  };

  const handleCancelDeleteList = async () => {
    openCancelDeleteDialog(false)
    // Delete API
    dispatch(putDeleteMyGoal(serialDetail, { serial: serialDetail }))
      .then(resp => {
        if (resp.success) {
          openSuccessCancelDeleteDialog(true)
          dispatch(getGoalList()).then((resp) => {
            setTitleName(state.name);
            setDataList(state.goal_items);
            setLoadingData(false)
            handleTotalPage(state.goal_items);
            setEvaluatorSerial(resp.data.kpi_form.form_evaluate_data[0].serial)
          })
        }
      })
  };

  const handleClearClick = () => {
    setTargetValue(null)
  }

  const updateGoal = () => {
    openUpdateDialog(false);
    // openSuccessAddDialog(true);
    // Do API here /goals/${id}/progress

    let target = targetValue;
    if (targetValue && targetValue.indexOf('/') > 0) {
      var splitValue = target.split('/')
      target = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
    }

    const sendData = {
      goal_id: goalDetail?.goal?.serial,
      target_value: target,
      goal_progress_data: progressValue,
      remark: remark,
      date: asOfDate
    }

    dispatch(putUpdateProgress(goalDetail?.goal?.serial, sendData))
      .then((resp) => {
        if (resp.success) {
          dispatch(getMyGoalDetail(serialForUpdate))
            .then(resp => {
              setGoalDetail(resp.data)
              setTargetValue(resp.data.goal_progress.actual_value)
              loadDataGoal();
            })
        }
        openSuccessAddDialog(true);
      })
  }
  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val)
  };
  const handleCancelDeleteDialog = (val) => {
    openCancelDeleteDialog(val)
  };

  const _ = require("lodash");
  const [filteredList, setFilteredList] = React.useState([]);
  const [perPage, setPerPage] = React.useState(12);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
  const [isCancelDeleteDialogOpen, openCancelDeleteDialog] = React.useState(false);
  const [isSuccessCancelDeleteDialogOpen, openSuccessCancelDeleteDialog] = React.useState(false);
  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
  const [isUpdateDialogOpen, openUpdateDialog] = React.useState(false);
  const [serialForUpdate, setSerialForUpdate] = React.useState(null)
  const [evaluatorSerial, setEvaluatorSerial] = React.useState(null);
  const [goalDetailData, setGoalDetailData] = React.useState(null)
  const [goalDetail, setGoalDetail] = React.useState({});
  const [searchData, setSearchData] = React.useState(null)
  const [targetValue, setTargetValue] = React.useState(null);
  const [progressValue, setProgressValue] = React.useState(null);
  const [targetCondition, setTargetCondition] = React.useState(null);
  const [goalProgressOption, setGoalProgressOption] = React.useState([]);
  const [editOwner, setEditOwner] = React.useState(false)
  const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
  const [asOfDate, setAsOfDate] = React.useState(Util.formatDate(new Date()));
  const [remark, setRemark] = React.useState("");
  const [goalScaleData, setGoalScaleData] = React.useState([]);

  const handleTotalPage = (data) => {
    const List = data;
    const totalPage =
      Math.ceil(List.length / perPage) === 0
        ? 1
        : Math.ceil(List.length / perPage);
    setTotalPage(totalPage);
  };

  // update qty for each status when list changed

  const loadDataGoal = () => {
    dispatch(getGoalList()).then((resp) => {
      setTitleName(state.name);
      setDataList(state.goal_items);
      setLoadingData(false)
      handleTotalPage(state.goal_items);
      setEvaluatorSerial(resp.data.kpi_form.form_evaluate_data[0].serial)
    })
  }
  useEffect(() => {
    loadDataGoal()
  }, [filteredList]);

  const [dataList, setDataList] = React.useState([])
  const [titleName, setTitleName] = React.useState(null)
  const [serialDetail, setSerialDetail] = React.useState(null)
  const [checkboxStatus, setCheckboxStatus] = React.useState("all");
  const [filterCheckbox, setFilterCheckbox] = React.useState({
    selectAll: false,
    draft: true,
    new: true,
    update: true,
    pending: true,
    approved: true,
    pending_delete: true,
  })
  const [checkbox, setCheckbox] = React.useState([true, true, true, true, true, true, false]);
  const [loadingData, setLoadingData] = React.useState(true)
  const [fullVersion, setFullVersion] = React.useState(true);
  const [goalProgressMockup, setGoalProgressMockup] = React.useState({})


  const pagingTotalItem = [12, 24, 36];

  const open = Boolean(anchorEl2);
  const id = open ? 'simple-popover' : undefined;

  const gotoDetail = (data) => {
    Object.assign(data, { goalSerial: data.serial })
    Object.assign(data, { serial: evaluatorSerial })
    if (data.is_cascaded) {
      Object.assign(data, { sendGoalType: data.type?.code === 'team' ? 2 : data?.type.code === 'personal' ? 3 : 1 })
    }
    Object.assign(data, { statusForm: state.statusForm })
    Object.assign(data, { isCreatable: state.isCreatable })
    Object.assign(data, { historyTemplate: state.historyTemplate })
    Object.assign(data, { viewSerial: state.viewSerial })
    goto(`/mygoal-detail/${data.goalSerial}`, data)
  }

  const goto = (route, data) => {
    if (data) {
      navigate("/kpi" + route, { replace: false, state: data });
    } else {
      navigate("/kpi" + route, { replace: false });
    }
  }

  const handleCheckbox = (data) => {
    let tmp = [...checkbox]
    let filterCheck = { ...filterCheckbox }
    if (data === "all") {
      console.log(checkboxStatus)
      if (checkboxStatus === "indeterminate") {
        tmp = tmp.map(item => item = true)
        filterCheck.selectAll = true
      } else if (checkboxStatus === "all") {
        tmp = tmp.map(item => item = false)
        filterCheck.selectAll = false
        filterCheck.approved = false
        filterCheck.draft = false
        filterCheck.new = false
        filterCheck.pending = false
        filterCheck.pending_delete = false
        filterCheck.update = false
      } else if (checkboxStatus === "none") {
        tmp = tmp.map(item => item = true)
        filterCheck.selectAll = true
      }
    } else if (data === "draft") {
      tmp[0] = !tmp[0]
      filterCheck.draft = tmp[0]
    } else if (data === "new") {
      tmp[1] = !tmp[1]
      filterCheck.new = tmp[1]
    } else if (data === "update") {
      tmp[2] = !tmp[2]
      filterCheck.update = tmp[2]
    } else if (data === "pending") {
      tmp[3] = !tmp[3]
      filterCheck.pending = tmp[3]
    } else if (data === "approved") {
      tmp[4] = !tmp[4]
      filterCheck.approved = tmp[4]
    } else if (data === "pending_delete") {
      tmp[5] = !tmp[5]
      filterCheck.pending_delete = tmp[5]
    }
    setCheckbox(tmp);
    setFilterCheckbox(filterCheck)
  };

  const checkCheckboxStatus = () => {
    let countChecked = 0
    let result = "none"
    let filterCheck = { ...filterCheckbox }
    checkbox.forEach(item => {
      if (item) countChecked++
    })
    if (countChecked === checkbox.length) {
      result = "all"
      filterCheck.selectAll = true;
    } else if (countChecked > 0 && countChecked < checkbox.length) {
      result = "indeterminate"
      filterCheck.selectAll = false;
    }

    setCheckboxStatus(result);
    setFilterCheckbox(filterCheck)
  }

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));

  const statusBox = (data, isCenter) => {
    if (data == 'new') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.new')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'approved' || data?.name == 'approved') {
      return (
        <Box style={{ backgroundColor: '#5DA1961A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is approved'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#5DA196" style={{ cursor: 'default' }}>
              {t('label.status.approve')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending_delete' || data == 'pending delete' || data?.description === 'pending_delete') {
      return (
        <Box style={{ backgroundColor: '#CC60581A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is awaiting approval for deletion.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#CC6058" style={{ cursor: 'default' }}>
              {t('label.status.pendingDelete')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending' || data?.name == 'pending') {
      return (
        <Box style={{ backgroundColor: '#F280261A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is waiting for approved.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#F28026" style={{ cursor: 'default' }}>
              {t('label.status.pending')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'update') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal updates already and has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.update')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else {
      return (
        <Box style={{ backgroundColor: data?.color?.background, width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: (data?.name === 'ยังไม่ได้ดำเนินการ' || data?.name === 'Not Started') ? '1px solid #DADADA4A' : `0px` }}>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={data?.color?.font}>
            {/* {upperFirstWord(data?.name)} */}
            {data?.name == 'in progress' ? t('label.status.inProgress') : data?.name === 'Not Started' ? t('label.status.notStart') : upperFirstWord(data?.name)}
          </Typography>
        </Box>
      )
    }
  }

  const convertDateFormat = (list) => {
    if (list.metric.description == 'Date') {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
          {`${list.target_value ? `${list.target_value} ${list.unit?.description || ''}` : '-'}`}
        </Typography>
      )
    } else {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
          {`${list.target_value ? `${list.target_value} ${list.unit?.description || ''}` : '-'}`}
        </Typography>
      )
    }
  }

  const upperFirstWord = (str) => {
    if (str) {
      var splitStr = str.toString().toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }
  }

  const searchGoalList = (e) => {
    setSearchData(e.target.value)
  }

  const setDataForUpdateDialog = (data) => {
    setRemark("")
    openUpdateDialog(true);
    setSerialForUpdate(data.serial)
    dispatch(getMyGoalDetail(data.serial))
      .then(resp => {
        setGoalDetail(resp.data)
        if ((resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date') && resp?.data?.goal_progress?.actual_value !== '') {
          var splitValue = resp?.data?.goal_progress?.actual_value?.split('/')
          var target = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
          setTargetValue(target || null)
        } else {
          var date = null
          if (resp?.data?.goal_progress?.actual_value === '' && (resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date')) {
            date = dayjs().format('MM/DD/YYYY')
          } else {
            date = resp?.data?.goal_progress?.actual_value || null
          }
          setTargetValue(date)
        }
        setProgressValue(resp?.data?.goal_progress?.goal_progress_data?.serial)
        setEditOwner(resp?.data?.is_owner)
      })
    dispatch(getMyGoalProgress(data.serial))
      .then(resp => {
        if (resp.success)
          setGoalProgressOption(resp.data.goal_progress_data)
        setGoalScaleData(resp.data.goal_scale)
        setTargetCondition(resp?.data?.goal_progress?.target_condition)
      })
  }
  useEffect(() => {
    var mockupProgress = {
      code: "not_started",
      color: "{\"font\": \"#DADADA\", \"background\": \"#FFFFFF\"}",
      is_default: true,
      name: "Not Started",
      seq: 1,
      serial: "bfaeaf1f-f5ad-4ddb-b02d-624f05d16da0"
    }
    mockupProgress.color = JSON.parse(mockupProgress.color)
    setGoalProgressMockup(mockupProgress)
    checkCheckboxStatus()
  }, [checkbox])

  // ----------------------------------
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
    inactiveSvg: {
      "& > path": {
        fill: "#D0D0D0"
      },
      '& g > path': {
        fill: '#D0D0D0'
      },
    },
  };
  const navigate = useNavigate();
  const acceptConsent = (data) => {
    navigate(data, { replace: false });
  }
  return (
    <>
      <Helmet>
        <title>MyGoal | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => acceptConsent('/kpi/home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto(`/mygoal${state.viewSerial ? '/' + state.viewSerial : ''}`, state)}>
                {` My Goal`}
              </span> /
              <span style={styles.end} >
                {` ${titleName}`}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container direction="row" justifyContent="space-between" style={{ height: '45px' }}>
            <Grid item >
              <Typography fontSize={36} lineHeight="39.6px" fontWeight="600" color="#404349">
                {titleName}
              </Typography>
            </Grid>
            <Grid item>
              <Grid container direction="row">
                <Grid item pb={2} pr={2}>
                  <TextField
                    fullWidth
                    id="input-with-icon-textfield"
                    placeholder="Search"
                    size="small"
                    sx={{ background: "#fff", height: "40px" }}
                    className="searchTextField-h48"
                    value={searchData}
                    onChange={searchGoalList}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search style={{ color: "#C4C4C4" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick2}
                    color="black"
                    variant="outlined"
                    sx={{ marginRight: '10px' }}
                    aria-describedby={id}
                    style={{ textTransform: 'none' }}
                  >
                    <FilterIcon style={{ width: '20px', height: '20px' }} />
                    <Typography ml={1}>{t("mygoal.label.filters")}</Typography>
                  </Button>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl2}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    {checkbox?.length > 0 ?
                      (<Box
                        sx={{
                          p: 1,
                        }}>
                        <Box
                          style={{ "padding-left": "14px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            style={{ fontSize: '14px' }}
                            label={t("label.selectAll")}
                            control={
                              <Checkbox
                                checked={checkboxStatus === 'all'}
                                indeterminate={checkboxStatus === 'indeterminate'}
                                onChange={() => handleCheckbox("all")}
                                xs={{ pl: 0 }}
                              />
                            }
                          />
                        </Box>
                        {false &&
                          <Box
                            style={{ "padding-left": "12px", "padding-right": "4px" }}
                            sx={{
                              display: "flex",
                              alignItems: "center"
                            }}>
                            <FormControlLabel
                              sx={{ ml: "0!important" }}
                              style={{ fontSize: '14px' }}
                              label="Draft"
                              control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[0]} onChange={() => handleCheckbox("draft")} />}
                            />
                          </Box>
                        }
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label="New"
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[1]} onChange={() => handleCheckbox("new")} />}
                          />
                        </Box>
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label="Update"
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[2]} onChange={() => handleCheckbox("update")} />}
                          />
                        </Box>
                        {false &&
                          <Box
                            style={{ "padding-left": "12px", "padding-right": "4px" }}
                            sx={{
                              display: "flex",
                              alignItems: "center"
                            }}>
                            <FormControlLabel
                              sx={{ ml: "0!important" }}
                              style={{ fontSize: '14px' }}
                              label="Pending"
                              control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[3]} onChange={() => handleCheckbox("pending")} />}
                            />
                          </Box>
                        }
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label="Approved"
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[4]} onChange={() => handleCheckbox("approved")} />}
                          />
                        </Box>
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label="Pending Delete"
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[5]} onChange={() => handleCheckbox("pending_delete")} />}
                          />
                        </Box>
                      </Box>) : null
                    }
                  </Popover>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction="row">
            <Grid item>
              <Typography fontSize={18} fontWeight={400} color='#A3A3A3' mt={1} >
                Total Goals:&nbsp;
              </Typography>
            </Grid>
            <Grid item>
              <Typography fontSize={18} fontWeight={400} color="primary" mt={1} >
                {dataList.filter((item) => {
                  if (filterCheckbox.selectAll) {
                    return item
                  } else {
                    if (filterCheckbox[item.goal_status?.description]) {
                      return item
                    }
                  }
                }).length}&nbsp;
              </Typography>
            </Grid>
            <Grid item>
              <Typography fontSize={18} fontWeight={400} color='#A3A3A3' mt={1} >
                Goals
              </Typography>
            </Grid>
          </Grid>
          {loadingData == false ?
            <Grid container>
              {dataList.filter((item) => {
                if (
                  item?.name?.toLowerCase().indexOf(searchData) >= 0 ||
                  item?.progress_status?.descritption?.toLowerCase().indexOf(searchData) >= 0 ||
                  item?.weight?.toLowerCase().indexOf(searchData) >= 0 ||
                  item?.metric?.description?.toLowerCase().indexOf(searchData) >= 0 ||
                  item?.type?.name?.toLowerCase().indexOf(searchData) >= 0 ||
                  item?.target_value?.toLowerCase().indexOf(searchData) >= 0 ||
                  item?.unit?.description?.toLowerCase().indexOf(searchData) >= 0 ||
                  item?.actual_value?.toLowerCase().indexOf(searchData) >= 0
                )
                  return item
                else {
                  if (!searchData)
                    return item
                }
              }).map((data, idx) => {
                return (
                  idx < perPage &&
                  <Grid key={idx} lg={6} style={{ marginTop: '20px', paddingRight: '10px' }}>
                    <Card style={{ minHeight: "410px" }}>
                      <CardContent>
                        <Grid item lg={12} xs={12} container>
                          <Grid
                            item
                            lg={8}
                            xs={12}
                            display="flex"
                            alignItems="center"
                            textAlign="left"
                          >
                            <Grid item direction="column">
                              <Tooltip disabledFocusListener title={data.name}>
                                <Typography fontSize={20} lineHeight="15px" color="#404349" fontWeight="600" onClick={() => { gotoDetail(data) }} style={{ cursor: 'pointer' }}
                                  sx={{
                                    display: '-webkit-box',
                                    overflow: 'hidden',
                                    WebkitBoxOrient: 'vertical',
                                    WebkitLineClamp: 2,
                                    lineHeight: '24px'
                                  }}
                                >
                                  {data.name}
                                </Typography>
                              </Tooltip>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            lg={4}
                            xs={12}
                            display="flex"
                            alignItems="right"
                            justifyContent="flex-end"
                          >
                            <Grid item mt={0.3}>
                              {statusBox(Object.keys(data.progress_status).length > 0 ? data.progress_status : goalProgressMockup)}
                            </Grid>
                            <Grid item sx={{ paddingLeft: '15px', paddingTop: '3px' }}>
                              <IconButton
                                aria-label="more"
                                id="long-button"
                                aria-controls={openOption ? 'long-menu' : undefined}
                                aria-expanded={openOption ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={(e) => handleClick(e, data)}
                                sx={{
                                  borderRadius: '5px', border: '1px solid #E5E5E5', paddingLeft: '1px', paddingRight: '1px', paddingTop: '6px', paddingBottom: '6px',
                                  "&:hover": {
                                    backgroundColor: "#EFF6F4"
                                  }
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            </Grid>
                            <Menu
                              id="long-menu"
                              MenuListProps={{
                                'aria-labelledby': 'long-button',
                              }}
                              anchorEl={anchorEl}
                              open={openOption}
                              onClose={handleOption}
                              PaperProps={{
                                style: {
                                  maxHeight: 48 * 4.5,
                                  width: '20ch',
                                  boxShadow: '0 0 1px 0 rgb(0 0 0 / 31%), 0 2px 6px -3px rgb(0 0 0 / 25%)',
                                },
                              }}
                            >
                              {options.map((option) => (
                                <MenuItem key={option} onClick={() => handleOption(option, goalDetailData)} disabled={(option === t('mygoal.label.delete') && goalDetailData?.is_owner === false) || (option === t('mygoal.label.edit') && goalDetailData?.progress_status?.description === 'pending_delete') || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && state?.workflowEnd) || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && !state?.isCreatable)}
                                  sx={{ color: (option === t('mygoal.label.delete') && goalDetailData?.progress_status?.description === 'pending_delete') ? '#CC6058' : "#404349" }}
                                  onMouseEnter={(e) => e.target.style.backgroundColor = '#EFF6F4'}
                                  onMouseLeave={(e) => e.target.style.backgroundColor = '#ffffff'}
                                >
                                  {
                                    option == t('mygoal.label.viewDetail') ?
                                      <EyeIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                                      : option == t('mygoal.label.edit') ?
                                        <EditIcon style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : styles.inactiveSvg} />
                                        : option === t('mygoal.label.delete') &&
                                          goalDetailData?.progress_status?.description === 'pending_delete' ?
                                          <CancelDelete style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : styles.inactiveSvg} />
                                          : <DeleteIcon style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : styles.inactiveSvg} />
                                  }
                                  {(option === t('mygoal.label.delete') && goalDetailData?.progress_status?.description === 'pending_delete') ? t('mygoal.label.cancelDeleteBtn') : option}
                                </MenuItem>
                              ))}
                            </Menu>
                          </Grid>
                        </Grid>
                        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                        <Grid container lg={12} xs={12} mt={3}>
                          <Grid lg={4} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                              {t('mygoal.label.goalWeight')}
                            </Typography>
                          </Grid>
                          <Grid lg={8} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                              {data.weight}
                            </Typography>
                          </Grid>
                          <Grid lg={4} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                              {t('mygoal.label.goalMetric')}
                            </Typography>
                          </Grid>
                          <Grid lg={8} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                              {data.metric.description}
                            </Typography>
                          </Grid>
                          <Grid lg={4} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                              {t('mygoal.label.goalType')}
                            </Typography>
                          </Grid>
                          <Grid lg={8} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                              {data.type.name}
                            </Typography>
                          </Grid>
                          <Grid lg={4} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                              {t('mygoal.label.startEndDate')}
                            </Typography>
                          </Grid>
                          <Grid lg={8} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                              {`${data.start_date} - ${data.end_date}`}
                            </Typography>
                          </Grid>
                          <Grid lg={4} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                              {t('mygoal.label.targetValue')}
                            </Typography>
                          </Grid>
                          <Grid lg={8} xs={12} mb={'15px'}>
                            {convertDateFormat(data)}
                          </Grid>
                          <Grid lg={4} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                              {t('mygoal.label.actualValue')}
                            </Typography>
                          </Grid>
                          <Grid lg={8} xs={12} mb={'15px'}>
                            <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                              {`${data.actual_value || '-'}`}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                        <Grid container direction="row" style={{ alignItems: 'center', paddingTop: "15px" }}>
                          <Grid xs={12} lg={6}>
                            <BootstrapTooltip
                              placement="right"
                              arrow
                              title={data.owner?.full_name}
                              style={{ marginLeft: '5px' }}
                            >
                              <Avatar
                                src={data.owner?.photo}
                                sx={{
                                  width: 30,
                                  height: 30,
                                }}
                              >
                              </Avatar>
                            </BootstrapTooltip>
                          </Grid>
                          <Grid xs={12} lg={6} style={{ textAlign: 'right', paddingRight: '5px', }}>
                            {(state.statusForm?.name === 'approved' && data.is_owner === true)
                              ?
                              <Typography color='#5DA196' style={{ cursor: 'pointer' }} onClick={() => { setDataForUpdateDialog(data) }}>
                                <Icon style={{ color: '#5DA196', fontSize: 18, paddingTop: "3px", marginRight: "3px" }}>{'rotate_left'}</Icon>
                                {t("mygoal.label.update")}
                              </Typography>
                              :
                              <Typography color='#DADADA'>
                                <Icon style={{ color: '#DADADA', fontSize: 18, paddingTop: "3px", marginRight: "3px" }}>{'rotate_left'}</Icon>
                                {t("mygoal.label.update")}
                              </Typography>
                            }
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
            :
            <Grid container spacing={2} mt={0}>
              <Grid item lg={12} md={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  p={1}
                  sx={{ minHeight: "400px" }}
                >
                  <Box>
                    <img src={fileBrowser} alt="browser" />
                  </Box>
                  <Box>
                    <Typography variant="sub_label">{t('competency.nodata')}</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          }
          {loadingData == false &&
            <Grid container direction="row" style={{ marginTop: '85px' }}>
              <Grid container xs={2} direction="row">
                <Grid item mt={1}>
                  <Typography fontSize={16} fontWeight={400} color={'#939393'} fontHeight={'24px'}>
                    {t('mygoal.label.itemPer')}
                  </Typography>
                </Grid>
                <Grid item ml={1}>
                  <Select
                    labelId="metric"
                    id="metric"
                    input={<OutlinedInput size="small" />}
                    value={perPage}
                    onChange={(val) => { setPerPage(val.target.value) }}
                  >
                    {pagingTotalItem.map((option) => {
                      return <MenuItem key={option} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </Grid>
              </Grid>
              <Grid lg={6} xs={12} item textAlign="center">
              </Grid>
              <Grid container lg={4} xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'flex-end', cursor: 'pointer' }}>
                <CustomPagination
                  setCurrentPage={handleSetCurrentPage}
                  selected={currentPage}
                  count={totalPage}
                ></CustomPagination>
              </Grid>
            </Grid>
          }
          <Dialog onBackdropClick={() => { return false }} open={isUpdateDialogOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row">
                <Grid item lg={11}>
                  <Typography fontSize={24} fontWeight="600" color="#404349">
                    {t('mygoal.label.updateGoal')}
                  </Typography>
                </Grid>
                <Grid item lg={1} style={{ textAlign: 'right' }}>
                  <Typography color='#404349' style={{ cursor: 'pointer', paddingTop: '8px' }} onClick={handleCloseDialog}>
                    X
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ paddingTop: "20px" }} />
              <Grid container>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalToUpdate')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="primary">
                    {goalDetail.goal?.name}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalMetric')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {goalDetail.goal_progress?.goal_metric.description}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.targetValue')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {Util.upperFirstWord(targetCondition ?? '')} {goalDetail.goal_progress?.target_value} {goalDetail.goal_progress?.unit && goalDetail.goal_progress?.unit !== "-" ? goalDetail.goal_progress?.unit : ""}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.resultAsOf')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2} color="#404349">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      format="dd/MM/yyyy"
                      value={asOfDate}
                      onChange={(newValue) => {
                        if (newValue) {
                          setAsOfDate(Util.formatDate(newValue));
                        } else {
                          setAsOfDate(null)
                        }
                      }}
                      style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: asOfDate ? '#CED4DA' : '#CC6058' }}
                      inputProps={{
                        placeholder: "As of date", sx: {
                          "&::placeholder": {
                            color: "#AAAAAA"
                          },
                          "&borderColor": {
                            color: '#CED4DA'
                          },
                          "color": '#404349'
                        }
                      }}
                      renderInput={(params) => <TextField {...params}
                        fullWidth
                        size="small"
                        style={{ color: '#404349' }}
                      />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.actualValue')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2} color="#404349">
                  {goalDetail?.goal_progress?.goal_metric?.options?.type === 'date'
                    ?
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Grid container direction="row">
                        <Grid item lg={10}>
                          <DesktopDatePicker
                            format="dd/MM/yyyy"
                            value={targetValue}
                            onChange={(newValue) => {
                              if (newValue) {
                                setTargetValue(Util.formatDate(newValue));
                              } else {
                                setTargetValue(null)
                              }
                            }}
                            style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: targetValue ? '#CED4DA' : '#CC6058' }}
                            inputProps={{
                              placeholder: "Current Value", sx: {
                                "&::placeholder": {
                                  color: "#AAAAAA"
                                },
                                "&borderColor": {
                                  color: '#CED4DA'
                                },
                                "color": '#404349'
                              }
                            }}
                            renderInput={(params) => <TextField {...params}
                              fullWidth
                              size="small"
                              style={{ color: '#404349' }}
                            />}
                          />
                        </Grid>
                        <Grid item>
                          <IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginLeft: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>
                        </Grid>
                      </Grid>
                    </LocalizationProvider>
                    :
                    (!goalDetail?.goal_progress?.goal_metric?.options)
                      ?
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          value={targetValue}
                          onChange={(val) => { setTargetValue(val.target.value) }}
                          renderValue={(selected) => {
                            if (selected === null || selected === "") {
                              return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>;
                            } else {
                              return <Typography color="#404349">{selected}</Typography>
                            }
                          }}
                          endAdornment={<IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginRight: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>}
                        >
                          <MenuItem value={""}>
                            <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>
                          </MenuItem>
                          <MenuItem value={"Success"}>Success</MenuItem>
                          <MenuItem value={"Fail"}>Fail</MenuItem>
                        </Select>
                      </FormControl>
                      :
                      <TextField
                        autoComplete='off'
                        style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={targetValue} onChange={(e) => setTargetValue(e.target.value)} placeholder={t("corporateGoal.label.fillTheActualValue")} variant="outlined" size="small" fullWidth
                        InputProps={{
                          endAdornment: targetValue ? (
                            <IconButton onClick={handleClearClick}>
                              <ClearIcon />
                            </IconButton>
                          ) : undefined
                        }}
                      />

                  }
                  {
                    goalScaleData.length > 0 &&
                    <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="left" sx={{ textTransform: "uppercase", mt: 1 }}>
                      {t("corporateGoal.label.scaleLevel")} : {goalScaleData.length}
                    </Typography>
                  }
                </Grid>
                {/* <Grid item lg={2}></Grid> */}
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('mygoal.label.goalProgress')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      value={progressValue}
                      onChange={(val) => { setProgressValue(val.target.value) }}
                      sx={{ color: "#404349" }}
                      renderValue={(selected) => {
                        if (selected === null) {
                          return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>Fill the goal progress</Typography>;
                        } else {
                          return goalProgressOption?.find((item) => item.serial === selected)?.name
                          // Mockup Because api is not working
                        }
                      }}
                    >
                      <MenuItem disabled value={null}>
                        <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>Fill the goal progress</Typography>
                      </MenuItem>
                      {goalProgressOption?.map((item, key) => {
                        return <MenuItem key={key} value={item.serial} sx={{ color: "#404349" }}>{item.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.remark')}:
                  </Typography>
                </Grid>
                <Grid item lg={12} pt={'7px'}>
                  <TextField
                    autoComplete='off'
                    multiline
                    rows={2}
                    maxRows={4}
                    style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder={`Fill the remark`} variant="outlined" size="small" fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Box classes="mt-3">
                <Button onClick={handleCloseDialog} color="black" variant="outlined" style={{ marginRight: '35px', paddingLeft: '48px', paddingRight: '48px', textTransform: 'none', borderColor: '#DADADA !important' }}>
                  {t('mygoal.label.cancel')}
                </Button>
                <Button onClick={() => updateGoal()} color="primary" variant="contained" style={{ paddingLeft: '48px', paddingRight: '48px', textTransform: 'none' }}>
                  <Typography>
                    {t('mygoal.label.justUpdate')}
                  </Typography>
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
          <SimpleDialog open={isSuccessAddDialogOpen} setValue={openSuccessAddDialog} title={t('mygoal.popup.success')} text={t('mygoal.popup.update')} />
          <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={openSuccessDeleteDialog} text="Goal item was deleted successfully." title="Success" />
          <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title="Confirmation of deletion" text="Are you sure you want to delete this goal ?" cancel="No, I’m not sure" confirm="Yes, of course" />
          <ConfirmDialog open={isCancelDeleteDialogOpen} trash={true} doConfirm={handleCancelDeleteList} setValue={handleCancelDeleteDialog} title={`${t("mygoal.label.cancelDelete")}`} text={`${t("mygoal.label.cancelDeleteDesc")}`} cancel={t('mygoal.label.no')} confirm={t('mygoal.label.yes')} />
          <SimpleDialog open={isSuccessCancelDeleteDialogOpen} setValue={openSuccessCancelDeleteDialog} title={t('mygoal.popup.successCancel')} text={t('mygoal.popup.successCancelDesc')} />
        </Container>
      </Box>
    </>
  );
};
export default MyGoalList;
